export default __webpack_public_path__ + "static/media/filter.e3bd66e9.svg";